import React from "react";

const OrderConfirmation = () => {
  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center">
      <div className="bg-white p-6 rounded shadow text-center">
        <h1 className="text-2xl font-bold mb-4">Orden Creada</h1>
        <p className="text-gray-700">
          Tu orden ha sido creada correctamente. Recibirás información adicional pronto.
        </p>
      </div>
    </div>
  );
};

export default OrderConfirmation;
